import { render, staticRenderFns } from "./LongueursAchat.vue?vue&type=template&id=e06aa0e6&"
import script from "./LongueursAchat.vue?vue&type=script&lang=ts&"
export * from "./LongueursAchat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports